module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-collapse-item weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dof-collapse-item-content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "title weex-ct weex-div",
    style: ({
      'backgroundColor:active': _vm._isColmo ? 'rgba(255,255,255,0.14)' : _vm._isDiablo ? '#1d1f21' : '#fff'
    }),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onCollapseHandler($event)
      }
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['title-box', _vm.collapsed_ ? 'bottom-line' : ''],
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("title", null, {}), _vm._v(" "), _c('div', {
    staticClass: "dof-header-arrow-box weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("desc", null, {}), _vm._v(" "), (_vm._isColmo) ? _c('dof-iconfont', {
    ref: "arrow",
    attrs: {
      "code": '\u4814',
      "size": 48,
      "color": 'rgba(255,255,255,0.8)',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.onCollapseHandler
    }
  }) : _c('figure', {
    ref: "arrow",
    staticClass: "dof-header-arrow weex-el weex-image",
    attrs: {
      "src": _vm.arrowUp,
      "data-img-src": _vm.arrowUp,
      "weex-type": "image"
    }
  })], 2)], 2)])]), _vm._v(" "), _c('div', {
    ref: "slotBody",
    staticClass: "dof-item-body weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1425952e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1425952e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-collapse-item/index.vue
// module id = 568
// module chunks = 0 1